import React from 'react';

import { usePlanFeature } from 'hooks/usePlanFeature';
import { useUserRightsIn } from 'hooks/useUserRightsIn';
import { useUserTypeIn } from 'hooks/useUserTypeIn';

import { APIUserRight, APIUserType } from 'types/api';
import { PlanFeature } from 'types/app';

export type CanAccessProps = {
  allowedUserType?: APIUserType | APIUserType[] | undefined;
  forbiddenUserType?: APIUserType | APIUserType[] | undefined;
  allowedFor?: APIUserRight | APIUserRight[];
  forbiddenFor?: APIUserRight | APIUserRight[];
  requiresFeature?: PlanFeature;
  childProps?: Record<string, any>;
  children?: any;
  fallback?: React.ReactNode | React.ReactNode[] | null;
};

export const CanAccess: React.FC<CanAccessProps> = ({
  allowedUserType,
  forbiddenUserType,
  allowedFor,
  forbiddenFor,
  requiresFeature,
  childProps,
  children,
  fallback,
}) => {
  const userRights = useUserRightsIn();
  const userTypeIn = useUserTypeIn();
  const planIncludes = usePlanFeature();

  const canAccess = [
    [forbiddenFor, forbiddenFor && !userRights(forbiddenFor)],
    [forbiddenUserType, forbiddenUserType && !userTypeIn(forbiddenUserType)],
    [allowedUserType, allowedUserType && userTypeIn(allowedUserType)],
    [allowedFor, allowedFor && userRights(allowedFor)],
    [requiresFeature, requiresFeature && planIncludes(requiresFeature)],
  ].every(([condition, check]) => !condition || check);

  if (canAccess) {
    return children;
  } else if (childProps) {
    return (
      <>
        {React.Children.map(children, child =>
          React.cloneElement(child, childProps),
        )}
      </>
    );
  }

  return fallback || null;
};
